const EPHEMERAL_REGEX = /^deliver-[a-z0-9]+-(prod|dev)-ecs\.components\.product\.which\.co\.uk$/

/**
 * Determines which Kinde auth domain to use based on the current hostname.
 */
export const getKindeAuthDomain = (hostname: string): string => {
  if (['localhost', 'dev.internal.which.co.uk', 'test.internal.which.co.uk'].includes(hostname)) {
    return 'dev-auth.which.co.uk'
  }

  if (hostname === 'preprod.internal.which.co.uk') {
    return 'preprod-auth.which.co.uk'
  }

  if (EPHEMERAL_REGEX.test(hostname) && hostname.includes('-dev-')) {
    return 'dev-auth.which.co.uk'
  }

  return 'auth.which.co.uk'
}

/**
 * Generates the full Kinde logout redirect URL with security validation.
 */
export const getKindeRedirectUrl = (hostname?: string, origin?: string, _isBrowser?: boolean) => {
  const isBrowser = _isBrowser ?? typeof window !== 'undefined'
  const currentHostname = hostname || (isBrowser ? window.location.hostname : '')
  const rawOrigin = origin || (isBrowser ? window.location.origin : 'https://www.which.co.uk')

  const allowedExactOrigins = [
    'https://www.which.co.uk',
    'http://localhost:3000',
    'http://localhost:3200',
  ]

  let resolvedOrigin = 'https://www.which.co.uk'

  // 1. Validate the redirect origin (Security Check)
  try {
    const url = new URL(rawOrigin)
    const isExplicitlyAllowed = allowedExactOrigins.includes(url.origin)
    const isWhichSubdomain = url.hostname === 'which.co.uk' || url.hostname.endsWith('.which.co.uk')

    if (isExplicitlyAllowed || isWhichSubdomain) {
      resolvedOrigin = rawOrigin
    }
  } catch (e) {
    console.error('Invalid origin provided to getKindeRedirectUrl')
  }

  // 2. Determine the Auth Domain
  // If we're not in a browser and no hostname was provided, fallback to production auth
  const authDomain =
    !isBrowser && !currentHostname ? 'auth.which.co.uk' : getKindeAuthDomain(currentHostname)

  return `https://${authDomain}/logout?redirect=${resolvedOrigin}`
}
